import IconContainer, { IconContainerProps } from "./IconContainer";

export default function IconCheck(props: IconContainerProps) {
    return <IconContainer {...props}>
        check
    </IconContainer>
}
